import React from 'react';
import Container from 'react-bootstrap/Container';

// var width = Dimensions.get('window');
// console.log('width= ' + width);

export const Layout = (props) => (
    <div style={{ maxWidth: "100%",}} >
        {props.children}
    </div>
)